import React from 'react';
import {MasterLayout} from 'components/layouts';
import {PostDemand} from 'components/users';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';

class PostDemandPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.PostDemandPage;
  }

  render() {
    return (
      <MasterLayout>
        <PostDemand/>
      </MasterLayout>
    );
  }
}

export default MemberZone(PostDemandPage);


// WEBPACK FOOTER //
// ./pages/users/PostDemandPage.jsx